import Smartlook from 'smartlook-client';

import { ToastContainer } from 'lib/toast';

import { Toaster as SonnerToaster } from './components/ui/sonner';
import './App.css';
import { envConfig } from './config';
import { AppProvider } from './providers/app';
import { AppRoutes } from './routes';

import 'react-datepicker/dist/react-datepicker.css';
import '@assistant-ui/react/styles/index.css';
import '@assistant-ui/react/styles/modal.css';

Smartlook.init(envConfig.smartlookKey);
Smartlook.record({
  forms: true, // Enable form tracking
  numbers: true, //  Do not Mask numbers
  emails: true, // Do not mask emails
});

export function App() {
  return (
    <AppProvider>
      <AppRoutes />
      <SonnerToaster position="top-center" richColors />
      <ToastContainer />
    </AppProvider>
  );
}
